import styled from "styled-components";

export const FooterRoot = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent;

  > * {
    grid-column-start: 1;
    grid-row-start: 1;
  }
`

export const Title = styled.p`
  width: 700px;
  font-size: 26px;
  font-family: "NeueMachina";
  font-weight: 100;
  letter-spacing: 1px;
  margin: 0;
  line-height: 1;

  b {
    font-size: 60px;
    font-family: "BebasNeue";
  }

  .yellow {
    color: ${({theme}) => theme.mintYellowHeading};
  }

  .blue {
    color: ${({theme}) => theme.mintAqua};
  }
`

export const Map = styled.img`
  width: 100%;
  height: auto;
`